import { FC, PropsWithChildren } from 'react';

import { useSentryLoader } from '@/hooks/analytics/useSentryLoader';

export const SentryGateway: FC<PropsWithChildren> = ({ children }) => {
  useSentryLoader();

  return <>{children}</>;
};
